import { dealTypeFromJsonQuery, FDealType, isFlat, isSuburban, offerTypeFromJsonQuery } from './category';
import { TJsonQuery } from '../../packages/JsonQuery';
import { IAbUseExperiment } from '../types/abUseExperiments';
import { BX_HYBRID_SEARCH_EXPERIMENT } from 'shared/constants/experiments';

type Params = {
  jsonQuery: TJsonQuery;
  experiments: IAbUseExperiment[];
};

export function isHybridSearchRedirectNeeded({ jsonQuery, experiments }: Params): boolean {
  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const isCategoryValid =
    (dealType === FDealType.RentLongterm && isFlat(offerType)) ||
    (dealType === FDealType.Sale && isSuburban(offerType));

  const isHybridSearchExperimentEnabled = experiments.some(
    ({ groupName, experimentName }) =>
      experimentName === BX_HYBRID_SEARCH_EXPERIMENT && (groupName === 'B' || groupName === 'C'),
  );

  return isCategoryValid && isHybridSearchExperimentEnabled;
}
